import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })<PropsType>`
    height: auto;
`;

const VerticalMove = ( {className}: PropsType ): React.ReactElement => (
    <SvgWrapper
        width={16}
        height={16}
        fill='#000'
        className={className}
        viewBox='0 0 16 16'
        xmlSpace='preserve'
    >
        <path
            fill='#fill'
            d='M 7.5 0.5 L 5 3 L 7 3 L 7 5 L 1 5 L 1 6 L 14 6 L 14 5 L 8 5 L 8 3 L 10 3 Z M 1 7 L 1 8 L 14 8 L 14 7 Z M 1 9 L 1 10 L 7 10 L 7 12 L 5 12 L 7.5 14.5 L 10 12 L 8 12 L 8 10 L 14 10 L 14 9 Z '
            fillRule='evenodd'
        />
    </SvgWrapper>
);

export default VerticalMove;
